import {
  OutlinedInput as Input,
  InputLabel,
  ThemeProvider,
  Typography,
  Checkbox,
  Link,
  Divider,
  useMediaQuery,
} from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import AppBaseScreen from "../../components/AppBaseScreen";
import { useTranslation } from "react-i18next";
import { styles, theme } from "./theme";
import { Formik } from "formik";
import { useLocation, useNavigate, useParams } from "react-router";
import Logo from "../../assets/logo/rocketfuel-circular.svg";
import AppButton from "../../components/AppButton";
import { useDispatch, useSelector } from "react-redux";
import {
  getAppConfigurations,
  getPayeeData,
  getVersion,
  login,
  setBlockedStatus
} from "../../store/actions/AuthActions";
import { Decrypt, Encrypt } from "../../utils";
import { executeRecaptcha } from "../../utils/recaptcha";
import { showMessageBar } from "../../store/actions";
import { MESSAGE_BAR_TYPES, EMAIL_REGEX, SELF } from "../../utils/constants";
import { logActivity, logEvent, sendOtp, signUp } from "../../store/api";
import BlockedFullscreenDialog from "../../components/BlockedFullscreenDialog";
import config from "../../utils/config";
import { Google } from "@mui/icons-material";
import { EVENTS } from '../../utils/events';
import { useGoogleLogin } from '@react-oauth/google';
import { getConfigurationsSelector } from '../../utils/selectorHelpers';
import AppOtpScreen from "../../components/AppOtpScreen";
import { SET_USER } from "../../store/actions/actionTypes";
const Authpage = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const appConfiguration = useSelector(getConfigurationsSelector);
  const location = useLocation();
  const isLargeScreen = useMediaQuery((theme) => theme.breakpoints.up("md"));
  const [initialValues, setInititalValues] = useState({
    email: "",
  });

  const [showBlocked, setShowBlocked] = useState(false);
  const [email, setEmail] = useState("");
  const [merchantId, setMerchantId] = useState("");
  const [isInvite, setIsInvite] = useState(false);
  const [checked, setChecked] = useState(false);
  const [termsConditionsChecked, setTermsConditionsChecked] = useState(true);
  const [googleLogin, setGoogleLoading] = useState(false);
  const [showOtpScreen, setShowOtpScreen] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const route = useParams();
  const getVersionDetails = () => {
    dispatch(getVersion());
  }

  const initializeEmail = async () => {
    const em = location.state?.email;
    if (em) {
      setInititalValues({ ...initialValues, email: em });
      setEmail(em);
      return;
    }
    const sessionEmail = localStorage.getItem("email_payee");
    if (sessionEmail) {
      setInititalValues({
        email: sessionEmail,
      });
      setChecked(true);
      setTermsConditionsChecked(true);
    }
  }

  const clearPerformanceStatusShown = () => {
    sessionStorage.removeItem('performanceStatusShown');
  }
  useEffect(() => {
    getVersionDetails();
    validateInvite();
    dispatch(getAppConfigurations());
    clearPerformanceStatusShown();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const validateInvite = () => {
    try {
      if (route.code) {
        try {
          const code = decodeURIComponent(route.code);
          const data = JSON.parse(Decrypt(atob(code)));
          setMerchantId(data.merchantId);
          setInititalValues({
            email: data.email,
          });
          setIsInvite(true);
          log(data.email, data.merchantId);
        } catch (err) { }
      } else initializeEmail()
    } catch (err) {
      dispatch(showMessageBar(MESSAGE_BAR_TYPES.ERROR, err))
    }
  }
  useEffect(() => {
    dispatch(setBlockedStatus(false));
    clearPerformanceStatusShown();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [route]);

  const saveCreds = (ev) => {
    setChecked(ev.target.checked);
  };
  const saveTermsConditions = (ev) => {
    setTermsConditionsChecked(ev.target.checked);
  };
  const log = async (email, merchantId) => {
    try {
      const encryptedReq = Encrypt(
        JSON.stringify({
          email: email,
          merchantId,
          eventType: "INVITE_OPEN",
        })
      );
      logActivity({ encryptedReq });
    } catch (err) {
      dispatch(showMessageBar(MESSAGE_BAR_TYPES.ERROR, err));
    }
  };

  const getDisplay = () => {
    const sessionEmail = localStorage.getItem("getting-started");
    if (!sessionEmail) {
      localStorage.setItem("getting-started", true);
      return 0;
    }
    return !!sessionEmail?.trim()?.length;;
  };

  const onAuthSuccess = () => {
    if (!route.code) {
      setIsSubmitting(false);
    }
    dispatch(getPayeeData());
    if (getDisplay()) {
      navigate("/accounts");
    } else {
      navigate("/getting-started");
    }
    setGoogleLoading(false);
  };

  const handleClick = (element, values) => {
    logEvent({
      current: EVENTS.LOGIN_EVENT,
      activity: `Clicked on ${element}`,
      meta: { email: values.email }
    })
  }

  const onAuthFailed = (err) => {
    setIsSubmitting(false);
    if (err.response && err.response.data && err.response.data.message) {
      if (err.response.data.statusCode === 403) {
        logEvent({
          current: EVENTS.LOGIN_EVENT,
          activity: `User Blocked`,
        });
        setShowBlocked(true);
        return;
      }
      dispatch(
        showMessageBar(MESSAGE_BAR_TYPES.ERROR, err)
      );
    } else {
      let msg = err.message;
      if (err.message.includes("]")) {
        msg = err.message.split("]");
      } else if (err.message.includes(":")) {
        msg = err.message.split(":");
      }

      dispatch(
        showMessageBar(
          MESSAGE_BAR_TYPES.ERROR,
          msg.length > 1 ? msg[msg.length - 1] : msg
        )
      );
    }
    setGoogleLoading(false);
  };

  const responseGoogle = async (tokenResponse) => {
    handleClick('Google Login Inititated', {})
    try {
      logEvent({
        current: EVENTS.LOGIN_EVENT,
        activity: `Google Login Success`,
        meta: {}
      })
      const payload = {
        access_token: tokenResponse.access_token
      };
      dispatch(
        login(payload,
          onAuthSuccess,
          onAuthFailed,
          "google"
        )
      );
    } catch (err) {
      logEvent({
        current: EVENTS.LOGIN_EVENT,
        activity: `Google Login Failed`,
        meta: {}
      })
      setGoogleLoading(false);
      dispatch(showMessageBar(MESSAGE_BAR_TYPES.ERROR, err))
    }
  };

  const handleLinkFailure = async (values, err) => {
    try {
      if (appConfiguration?.otpProviders?.indexOf(SELF) > -1) {
        await sendOtp({
          email: values.email,
          recaptcha: await executeRecaptcha(),
        });
        setShowOtpScreen(true);
      } else {
        onAuthFailed(err);
      }
    } catch (err) {
      setIsSubmitting(false);
      dispatch(showMessageBar(MESSAGE_BAR_TYPES.ERROR, err));
    }

  }

  const validateOtp = async (otp) => {
    try {
      const payload = {
        data: {
          email: email,
          code: otp,
          recaptcha: await executeRecaptcha(),
        },
        headers: {}
      }
      const response = await signUp(payload);
      dispatch({
        type: SET_USER,
        payload: {
          ...response.result
        },
      });
      setShowOtpScreen(false);
      onAuthSuccess();
      return { success: true };
    } catch (err) {
      return { error: err };
    }
  }
  const handleSignUp = async (values) => {
    try {
      if (checked) {
        localStorage.setItem("email_payee", values.email);
      }
      setEmail(values.email);
      setIsSubmitting(true);
      values.merchantId = merchantId;
      dispatch(login(values, onAuthSuccess, onAuthFailed, null, handleLinkFailure));
    } catch (err) {
      if (!route.code) {
        setIsSubmitting(false);
      }
    }
  };

  const loginGoogle = useGoogleLogin({
    onSuccess: responseGoogle,
    onError: (err) => {
      dispatch(showMessageBar(MESSAGE_BAR_TYPES.ERROR, err));
    },
  });
  const handleOtpPopupclose = () => {
    setShowOtpScreen(false);
    setIsSubmitting(false);
  }
  if (showBlocked) {
    return <BlockedFullscreenDialog showBlocked={showBlocked} setShowBlocked={setShowBlocked} />;
  }

  return (
    <AppBaseScreen isHeader={false} childsize={"xs"}>
      <ThemeProvider theme={theme}>
        <AppOtpScreen
          email={email}
          show={showOtpScreen}
          validateOtp={validateOtp}
          onClose={handleOtpPopupclose}
        />
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            marginBottom: 2,
            marginTop: isLargeScreen ? "10%" : "3vh",
          }}
        >
          <Logo style={styles.logo} />
        </Box>
        <Typography fontSize={20} textAlign="center">
          {isInvite ? t("loginPage.title1") : t("loginPage.title")}
        </Typography>
        <Typography fontSize={16} textAlign="center">
          {isInvite ? t("loginPage.subtitle1") : t("loginPage.subtitle")}
        </Typography>
        <Formik
          enableReinitialize
          initialValues={initialValues}
          validate={(values) => {
            const errors = {};
            if (
              !EMAIL_REGEX.test(values.email)
            ) {
              errors.email = t("invalidEmail");
              handleClick('Login Error: Invalid Email', values)
            }
            return errors;
          }}
          onSubmit={handleSignUp}
          validateOnBlur={false}
          validateOnChange={false}
        >
          {({
            values,
            errors,
            handleChange,
            handleSubmit,
            /* and other goodies */
          }) => (
            <form autoComplete="off" onSubmit={handleSubmit} style={styles.form} className="test">
              <Box sx={{ display: "block" }}>
                <InputLabel>Email</InputLabel>
                <Input
                  type="text"
                  name="email"
                  placeholder={t("enterEmail")}
                  onChange={handleChange}
                  value={values.email}
                  autoComplete="off"
                  error={!!errors.email}
                  disabled={isInvite || isSubmitting}
                />
                {errors.email && (
                  <Typography fontSize={14} color={"#DC2626"}>
                    {errors.email}
                  </Typography>
                )}
                <Box display={"flex"} alignItems="center">
                  <Checkbox onChange={saveCreds} checked={checked} name="Remember Me login page" />
                  <Typography fontSize={14}>
                    {t("loginPage.rememberMe")}
                  </Typography>
                </Box>
                <Box display={"flex"} alignItems="center">
                  <Checkbox
                    onChange={saveTermsConditions}
                    name="T&C checkbox"
                    checked={termsConditionsChecked}
                  />
                  <Typography fontSize={14}>
                    {t("sigin.i-agree")}&nbsp;
                    <Link
                      href={config.TERMS_CONDITION}
                      target={"_blank"}
                      color={"#0088F5"}
                      onClick={() => handleClick('Terms Conditions', values)}
                    >
                      {t("sigin.TnC")}
                    </Link>
                    {t("sigin.and")}
                    <Link
                      href={config.PRIVACY_POLICY}
                      target={"_blank"}
                      color={"#0088F5"}
                      onClick={() => handleClick('Privacy Policy', values)}
                    >
                      {t("sigin.privacy-policy")}
                    </Link>
                  </Typography>
                </Box>
                <AppButton
                  loading={isSubmitting}
                  disabled={!values.email || !termsConditionsChecked || isSubmitting}
                  type="submit"
                  title={t("loginPage.continue")}
                />
                <Box width={"100%"} margin="20px 0px"></Box>
                {isInvite && (
                  <AppButton
                    buttontheme={"transparent"}
                    title={t("contact")}
                    onClick={() => handleClick('Contact Support Link', values)}
                    href={config.ZENDESK_SUPPORT}
                    target="_blank"
                    textAlign="center"
                  />
                )}
                <Divider
                  textAlign="center"
                  sx={{
                    background: "transparent",
                    "&::after": {
                      borderTop: "1px solid #0088F5",
                    },
                    "&::before": {
                      borderTop: "1px solid #0088F5",
                    },
                  }}
                >
                  <Typography
                    fontSize={14}
                    fontFamily={"Manrope"}
                    fontWeight={400}
                  >
                    {t('or')}
                  </Typography>{" "}
                </Divider>
                <AppButton
                  loading={googleLogin}
                  onClick={() => { setGoogleLoading(true); loginGoogle() }}
                  title={t("login with google")}
                  startIcon={<Google />}
                />
              </Box>
            </form>
          )}
        </Formik>
      </ThemeProvider>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          alignItems: 'center',
          marginTop: 5,
        }}
      >
        <Link sx={{ marginTop: 2 }} href={config.ABOUT_LINK} target="_blank" onClick={() => handleClick("About Us", {})}>{t("aboutUs")}</Link>
      </Box>
    </AppBaseScreen>
  );
};

export default Authpage;
